import draggable from './module/draggable';
import clipboard from './module/clipboard';
var directives = {
  draggable: draggable,
  clipboard: clipboard
};
export default directives;